import { style } from 'typestyle'
import { important } from 'csx'
export const f17i = style({ fontSize: important('17px') })
